var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alert",attrs:{"elevation":"3","dismissible":true,"type":_vm.value.type},model:{value:(_vm.value.active),callback:function ($$v) {_vm.$set(_vm.value, "active", $$v)},expression:"value.active"}},[_vm._v(" "+_vm._s(_vm.value.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }